/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SiteNavDropdownImageModule_navigationModule$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SiteNavDropdownContent_navigationModule$ref: FragmentReference;
export type SiteNavDropdownContent_navigationModule = {|
  +imageUrl: ?string,
  +$fragmentRefs: SiteNavDropdownImageModule_navigationModule$ref,
  +$refType: SiteNavDropdownContent_navigationModule$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SiteNavDropdownContent_navigationModule",
  "type": "NavigationModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SiteNavDropdownImageModule_navigationModule",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1b494936a181d3695e6f453d32225b08';
module.exports = node;
